module.exports = __webpack_public_path__ + "static/media/deleteCircle.78157a9b.svg";